import { MobDef } from '../mob';
import { BlockId } from '@shared/block-ids';

export const SHEEP_DEF: MobDef = {
  name: 'Sheep',
  width: 0.6,
  height: 1.0,
  health: 10,
  speed: 1.3,
  hostile: false,
  color: 0xffffff,
  bodyColor: 0xeeeeee,
  detectionRange: 0,
  attackDamage: 0,
  attackRange: 0,
  drops: [
    { id: BlockId.SNOW, min: 1, max: 2 }, // wool placeholder (using snow)
  ],
};
